import { render, staticRenderFns } from "./ThreeTabsPopup.vue?vue&type=template&id=7445e37f&"
import script from "./ThreeTabsPopup.vue?vue&type=script&lang=js&"
export * from "./ThreeTabsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports